import {UserEventsMap} from '../userEvents/UserEventsMap'
import sendUserEvent from '../userEvents/sendUserEvent'
import UserNameFormat from "../util/UserNameFormat";
import isTrialWithoutRenewal from "../userEvents/checks/isTrialWithoutRenewal";

const INTERCOM_WIDGET_API_URL = 'https://widget.intercom.io/widget/'
const INTERCOM_API_BASE = "https://api-iam.intercom.io"
const WATCH_ARTICLES_INTERVAL_MS = 500

function initIntercom({
    appId,
    userEmail,
    userName,
    userId,
    context,
}) {
    if (window.intercomSettings)
        return

    window.intercomSettings = {
        api_base: INTERCOM_API_BASE,
        user_id: 'c' + userId + '@' + context,
        app_id: appId,
        name: userName,
        email: userEmail,
        company: {
            id: context,
            name: context
        }
    };

    const widgetUrl = INTERCOM_WIDGET_API_URL + appId;
    //Provided by Intercom: https://developers.intercom.com/installing-intercom/web/installation/#website-visitors-v-logged-in
    (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src=widgetUrl;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();

    let lastDetectedArticle = null
    function watchArticle() {
        const mainFrame = document.getElementsByName("intercom-messenger-frame")[0]
        if (mainFrame) {
            const proxyFrame = mainFrame.contentDocument.getElementsByTagName("iframe")[0]
            if (proxyFrame) {
                const articleTitle = proxyFrame["title"]
                if (lastDetectedArticle !== articleTitle) {
                    lastDetectedArticle = articleTitle
                    sendUserEvent(UserEventsMap.ARTICLE_VISITED, {title: articleTitle})
                }
            } else {
                lastDetectedArticle = null
            }
        }
    }

    let watchArticleTimeId = 0
    window.Intercom('onShow', () => {
        watchArticleTimeId = setInterval(watchArticle, WATCH_ARTICLES_INTERVAL_MS)
    })

    window.Intercom('onHide', () => {
        lastDetectedArticle = null
        clearInterval(watchArticleTimeId)
    })
}

export function isIntercomEnabled() {
    return window.__GENERATED_CONSTANTS__.INTERCOM_APP_ID && isTrialWithoutRenewal()
}

export function openIntercom() {
    let count = 500 * 60 // 30 sec
    let intId = setInterval(function () {
        if (count-- <= 0) {clearInterval(intId)}
        if (window.Intercom) {
            clearInterval(intId)
            window.Intercom('show')
        }
    }, 500)
}

export default function initIntercomIfNeeded() {
    const appId = window.__GENERATED_CONSTANTS__.INTERCOM_APP_ID
    const loggedInUserId = window.__INIT_APP_DATA__.LOGGED_IN_USER
    const context = window.__GENERATED_CONSTANTS__.CLIENT_CODE

    let enabled = false
    if (appId && isTrialWithoutRenewal()) {
        initIntercom({
            appId,
            userEmail: loggedInUserId.email || 'devnull@actitime.com', // fallback
            userName: UserNameFormat.formatFML(
                loggedInUserId.firstName,
                loggedInUserId.lastName,
                loggedInUserId.middleName
            ),
            userId: loggedInUserId.id,
            context: context
        })
        enabled = true
    }

    return enabled
}


// WEBPACK FOOTER //
// ./web/js/intercom/initIntercom.js